export default function FinalReassurance() {
  return (
    <section className="py-16 px-6 lg:px-12">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-lg text-gray-700 font-medium">
          You're not committing to software — just seeing what's possible.
        </p>
      </div>
    </section>
  );
}
